import Vue from 'vue'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import {
  VMenu,
  VList,
  VListItem,
  VListItemGroup,
  VListItemTitle,
  VBtn,
  VIcon,
} from 'vuetify/lib'
import variables from '@/styles/_varsJs.scss'

export default Vue.extend({
  components: {
    AscTextFieldInput,
    VMenu,
    VList,
    VListItemGroup,
    VListItem,
    VListItemTitle,
    VBtn,
    VIcon,
  },

  data() {
    return {
      currentValue: null,
      menu: false,
      filterOptions: [
        { text: 'Equals', value: 'equals' },
        { text: 'Not Equal', value: 'notEqual' },
        { text: 'Less Than', value: 'lessThan' },
        { text: 'Less Than Or Equal', value: 'lessThanOrEqual' },
        { text: 'Greater Than', value: 'greaterThan' },
        { text: 'Greater Than Or Equal', value: 'greaterThanOrEqual' },
      ],
      selectedFilter: 'equals',
      selectedOptionIndex: 0,
    }
  },

  computed: {
    getHighlightColor() {
      return this.menu ? variables.accent500 : variables.gray500
    },
  },
  methods: {
    selectFilter(value, index) {
      this.selectedFilter = value
      this.menu = false
      this.selectedOptionIndex = index
      this.onFilterChanged()
    },

    onFilterChanged() {
      if (this.currentValue === '') {
        // Remove the filter
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged(null, null)
        })
        return
      }

      this.params.parentFilterInstance(instance => {
        instance.onFloatingFilterChanged(this.selectedFilter, this.currentValue)
      })
    },

    onParentModelChanged(parentModel) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.currentValue = ''
      } else {
        this.currentValue = parentModel.filter
      }
    },

    toggleMenu() {
      this.menu = !this.menu
    },
  },

  template: `<div class="d-flex autocomplete-number-filter">
  <asc-text-field-input ref="textFieldInput" :class="{ 'menu-open': menu }" color="primary" v-model.number="currentValue" type="number" min="0" @input="onFilterChanged" @click="toggleMenu" hide-spin-buttons dense hide-details style="margin-bottom: 0.5em;"></asc-text-field-input>
  <v-menu v-model="menu" ref="menu" :close-on-content-click="false" bottom left offset-y max-width="178" min-width="120">
     <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" depressed :class="{ 'menu-open': menu }" v-on="on" absolute small style="right:0">
           <v-icon size="16"  :color="getHighlightColor">mdi-filter</v-icon>
        </v-btn>
     </template>
     <v-list class="pa-0">
     <v-list-item>
     <asc-text-field-input placeholder="Filter" :class="{ 'menu-open': menu }" color="primary" v-model.number="currentValue" type="number" min="0" @input="onFilterChanged" autofocus hide-spin-buttons dense hide-details style="margin-bottom: 0.5em;"></asc-text-field-input>
     </v-list-item>
        <v-list-item-group v-model="selectedOptionIndex" color="primary">
           <v-list-item style="min-height:32px" v-for="(option, index) in filterOptions" :key="index" @click="selectFilter(option.value, index)">
              <v-list-item-title>{{ option.text }}</v-list-item-title>
           </v-list-item>
        </v-list-item-group>
     </v-list>
  </v-menu>
</div>`,
})
